import React from 'react'
import { connect } from 'react-redux'
import {
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarCidade from '../../actions/cidade/selecionarCidade';

export class Cidade extends React.Component {
  render () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
        <div className="geral">
          <div className="resumo">
            <div className="row">
              <div className="col-lg-5 col-xl-5">
                <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.cidade.nome}
              </div>

              <div className="col-lg-5 col-xl-5">
                <span className="titulo-mobile">UF:&nbsp;</span>{this.props.cidade.descricaoUf}
              </div>
              <div className="col-lg-2 col-xl-2">
                  <div className="acoes">
                    <div className="botoes">
                      <button type="button" className="btn btn-excluir"
                              data-toggle="modal"
                              data-target="#modalConfirmacaoExclusaoCidade"
                              onClick={() => this.props.selecionarCidade(this.props.cidade)}>
                        <i className="material-icons nav-icon">&#xe872;</i>
                      </button>
                      <button type="button" className="btn btn-editar ml-2"
                              data-toggle="modal"
                              data-target="#modalCadastrarCidade"
                              onClick={() => this.props.selecionarCidade(this.props.cidade)}>
                        <i className="material-icons nav-icon">&#xe150;</i>
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Autorizacao>
    )
  }
}

export function mapStateToProps () {
  return { }
}

export default connect(mapStateToProps, { selecionarCidade })(Cidade)
